import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DepositOwnerType, DepositType, DepositWithdrawalOption } from 'app/components/deposits/models/ownDepoist';
declare var jQuery: any;
import { DepoitsService } from 'app/components/deposits/depoits.service';

@Component({
  selector: 'app-own-deposits-cache-cheque',
  templateUrl: './own-deposits-cache-cheque.component.html',
  styleUrls: ['./own-deposits-cache-cheque.component.scss']
})
export class OwnDepositsForCacheChequeComponent implements OnInit, OnChanges {

  ownDepositList: DepositType[] = [];
  selectedDeposit = new DepositType();
  depositOwnerType = DepositOwnerType;
  depositWithdrawalOption = DepositWithdrawalOption;

  @Input() getDeposit;
  @Input() getUniqueId;
  @Input() hasError = false;
  @Input() depositeId = '#depositSelect';
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Input() optional = false;
  @Input() allDeposits = false;
  @Input() selectedFirst = false;
  @Input() isInvestment = false;
  @Input() legalShared; // مشترک حقوقی
  @Input() jari; // حساب جاری
  @Input() sharedTanha;
  @Input() showTitle = false;
  constructor(private depositService: DepoitsService) { }

  ngOnChanges(): void {
    if (this.ownDepositList !== null && this.ownDepositList.length > 0) {
      this.doStuff();
    }
  }

  ngOnInit() {
    this.getOwnDeposits();
  }

  filterList() {
    if (this.ownDepositList !== null && this.ownDepositList.length > 0) {
      this.ownDepositList = this.ownDepositList.filter(x => x.visible === true);
      if (this.legalShared) {
        this.ownDepositList = this.ownDepositList.filter(x => (x.depositOwnerType === this.depositOwnerType.SHARED || x.depositOwnerType === this.depositOwnerType.LEGAL));
      }
      if (this.jari) {
        this.ownDepositList = this.ownDepositList.filter(x => x.depositType.includes('جاری'));
      }
      if (this.sharedTanha) {
        this.ownDepositList = this.ownDepositList.filter(x => (x.depositOwnerType !== this.depositOwnerType.SHARED) || (x.depositOwnerType === this.depositOwnerType.SHARED && x.depositWithdrawalOption === this.depositWithdrawalOption.BE_TANHAYEE));
        this.ownDepositList = this.ownDepositList.filter(x => (x.depositType !== 'بلند مدت'));
        this.ownDepositList = this.ownDepositList.filter(x => (x.depositType !== 'بلند مدت ویژه'));
      }
      if (this.allDeposits) {
        const temp = new DepositType();
        // temp.depositType = 'همه سپرده ها';
        temp.depositNumber = 'همه سپرده ها';
        temp.uniqueId = '';
        this.ownDepositList.unshift(temp);
        this.selectedDeposit = this.ownDepositList[0];
        this.selectedFirst = true;
        this.notifyParent.emit(this.selectedDeposit);
      }

      if (this.getDeposit !== undefined && this.getDeposit.depositNumber) {
        this.selectedDeposit = this.ownDepositList.find(el => el.depositNumber === this.getDeposit.depositNumber);
        this.notifyParent.emit(this.selectedDeposit);
        return;
      } else {
        if (this.selectedFirst) {
          this.selectedDeposit = this.ownDepositList[0];
          this.notifyParent.emit(this.selectedDeposit);
          return;
        }
      }
      if (this.ownDepositList.length === 1) {
        this.selectedDeposit = this.ownDepositList[0];
        this.selectedFirst = true;
        this.notifyParent.emit(this.selectedDeposit);
      }
    }
  }
  doStuff() {
    // paya
    if (this.getUniqueId === '') {
      this.selectedDeposit = null;
      document.getElementsByClassName('select-form-control')[0].classList.remove('focused');
      return;
    }
    // karpooshe
    if (this.allDeposits && this.getDeposit.uniqueId === '') {
      this.selectedDeposit = this.ownDepositList[0];
      this.selectedFirst = true;
      this.notifyParent.emit(this.selectedDeposit);
    }

    if (this.getDeposit !== undefined && this.getDeposit.depositNumber) {
      this.selectedDeposit = this.ownDepositList.find(el => el.depositNumber === this.getDeposit.depositNumber);
      this.notifyParent.emit(this.selectedDeposit);
      return;
    }

    if (this.getDeposit === undefined) {
      this.selectedDeposit = this.ownDepositList[0];
      this.notifyParent.emit(this.selectedDeposit);
      return;
    }
  }
  getOwnDeposits() {
    this.ownDepositList = [];
    this.depositService.getOwnDepositsForCacheCheque().subscribe(
      res => {
        if (res.code === 0) {
          this.ownDepositList = res.content;
          sessionStorage.setItem('ownDeposits', JSON.stringify(this.ownDepositList));
          this.filterList();
        }
      }
    );
  }
  sendParentNotification(evt) {
    document.getElementById(this.depositeId).classList.add('focused');
    this.notifyParent.emit(this.selectedDeposit);
  }
  selectFirst() {
    if (this.ownDepositList && this.ownDepositList.length > 0 && !this.selectedDeposit) {
      this.selectedDeposit = this.ownDepositList[0];
      this.notifyParent.emit(this.selectedDeposit);
      document.getElementById(this.depositeId).classList.add('focused');
    }
  }
}
